import React, { useState, useCallback, useMemo } from "react";
import { useAppSelector } from "@/hooks";

import MainTemplate from "@/components/Templates/MainTemplate";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import FloatingBanner from "./FloatingBanner";
import CorporateForm from "./CorporateForm";
import CallBackForm from "./CallbackForm";

import theme from "@/foundation/Theme";
import useDisableIntercom from "@/hooks/useDisableIntercom";

import { mapAnnualMembershipData } from "./mapAnnualMembershipData";

import { PageContainer, PageWrapper } from "./style";

const AnnualMembershipPage = () => {
  useDisableIntercom();

  const { isLoading, success, error, data } = useAppSelector(
    (state) => state.membershipBenefitData
  );

  const [showCallbackModal, setShowCallbackModal] = useState(false);
  const [showCorporateModal, setShowCorporateModal] = useState(false);

  const handleCorporateFormView = useCallback(
    () => setShowCorporateModal((previous) => !previous),
    []
  );

  const handleCallbackFormView = useCallback(
    () => setShowCallbackModal((previous) => !previous),
    []
  );

  const annualMembershipData = useMemo(
    () => mapAnnualMembershipData(data),
    [data]
  );

  const banner = annualMembershipData?.banner || {};

  const Page = (
    <PageWrapper>
      <PageContainer>
        <LeftSection data={annualMembershipData} />
        <RightSection
          data={annualMembershipData}
          handleCallbackFormView={handleCallbackFormView}
        />
        {/* Currently Hiding Floating Banner - Corporate Form */}
        {false && (
          <FloatingBanner
            {...banner}
            handleCorporateFormView={handleCorporateFormView}
          />
        )}
        {showCorporateModal && (
          <CorporateForm
            handleCorporateFormView={handleCorporateFormView}
            defaultSlug={annualMembershipData?.form.defaultPackageSlug}
          />
        )}
        {showCallbackModal && (
          <CallBackForm
            handleCallbackFormView={handleCallbackFormView}
            defaultSlug={annualMembershipData?.form.defaultPackageSlug}
          />
        )}
      </PageContainer>
    </PageWrapper>
  );

  return (
    <MainTemplate
      success={success}
      error={error}
      headerBackgroundColor={theme.colors.white}
      hideRibbon
    >
      {Page}
    </MainTemplate>
  );
};

export default AnnualMembershipPage;
